import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthorizationFlowService } from '../services/authorization-flow.service';

/**
 * Los pasos 2, 3 y 4 dependen de la información que se carga en el paso 1.
 * Si no está (recarga directa de la url), se devuelve al inicio del flujo.
 */
@Injectable({
  providedIn: 'root'
})
export class FlowDataGuard  {

  constructor( private router: Router,
               private flowSrv: AuthorizationFlowService
   ) { }

  canActivate(): boolean | UrlTree {
    if (this.flowSrv.hasData) {
      return true;
    }
    return this.router.createUrlTree(['/aviso']);
  }
}
